module.exports = __webpack_public_path__ + "static/7-real-estate-a65d3bd14e1ea1eff64c6f74727779a9.jpg";